// TODO: Replace this with smarter way to query
// This is an array of Algolia objectIDs of featured products for the new store landing product callouts.
export const FEATURED_SUBSCRIPTIONS = [
  'doordash_giftcard_dashpass_gift_card_104',
  'wellness_coach_gold_wellness_coach_gold_annual',
  'headspace_annual_subscription',
  'classpass_7_credits', // TODO find out if this exists in Algolia - can only find 130 for US.
  'massage_envy_membership',
  'soothe_soothe_100_gift_card',
  'the_new_york_times_all_access_the_new_york_times_all_access',
];

export const FEATURED_PRODUCTS = [
  'tiger_tail_t_1000_vibration_massager',
  'garmin_approach_r10_garmin_approach_r10',
  'hygear_hygear_hyrope',
  'sony_intelligent_industry_leading_noise_canceling_headphones_sony_intelligent_industry_leading_noise_canceling_headphones_black',
  'sound_oasis_glo_to_sleep_advanced_sleep_therapy_mask_gts_2000se',
  'fluidstance_fluidstance_slope_white',
  'aura_air_aura_smart_air_purifier',
  'hyperice_hypersphere_mini_hyperice_hypersphere_mini',
];

export const FEATURED_SECTIONS: {
  [key: string]: string;
} = {
  DEFAULT: 'default',
  EXPIRING_FUNDS: 'expiring-funds',
  FEATURED_PRODUCTS: 'featured-products',
  NO_COST: 'no-out-of-pocket-cost',
  POPULAR: 'popular',
  VENDORS: 'vendors',
} as const;

export const TERMS = {
  ONE_TIME: 'one_time',
  MONTHLY: 'monthly',
};

export enum BannerType {
  ACCOUNT = 'account',
  ACCOUNT_LIST = 'account-list',
  STORE = 'store',
}

export const getProductCalloutImage = ({
  product_id,
}: {
  product_id: string;
}) => {
  const root_url =
    'https://files.plytix.com/api/v1.1/file/public_files/pim/assets/33/43/d8/62/62d84333e8b24d00200ff9fb/images';
  switch (product_id) {
    case 'aura_smart_air_purifier':
      return `${root_url}/d4/8b/59/63/63598bd48e7208840f74c846/aura_air_aura_smart_air_purifier.png`;
    case 'fightcamp_trackers_with_1_year_membership':
      return `${root_url}/d4/8b/59/63/63598bd46088c403f3c23ff5/fightcamp_trackers_fightcamp_trackers_with_1_year_membership.png`;
    case 'fitnesse_elite_band_bundle':
      return `${root_url}/d5/8b/59/63/63598bd528c20569eb0dc6c2/fitnesse_elite_band_fitnesse_elite_band_bundle.png`;
    case 'fluidstance_slope_white':
      return `${root_url}/d5/8b/59/63/63598bd56088c403f3c23ff6/fluidstance_fluidstance_slope_white.png`;
    case 'fluidstance_raise_24_walnut_finish_dark':
      return `${root_url}/d6/8b/59/63/63598bd6f7de7ce2c5238bcb/fluidstance_raise_24_fluidstance_raise_24_walnut_finish_dark.png`;
    case 'garmin_approach_r10':
      return `${root_url}/d6/8b/59/63/63598bd69dbdb8da0adb3c99/garmin_approach_r10_garmin_approach_r10.png`;
    case 'hygear_hyrope':
      return `${root_url}/d7/8b/59/63/63598bd76088c403f3c23ff7/hygear_hygear_hyrope.png`;
    case 'hyperice_hypersphere_mini':
      return `${root_url}/d7/8b/59/63/63598bd728c20569eb0dc6c4/hyperice_hypersphere_mini_hyperice_hypersphere_mini.png`;
    case 'hyperice_hypervolt_go_2':
      return `${root_url}/d8/8b/59/63/63598bd89dbdb8da0adb3c9b/hyperice_hypervolt_go_2_hyperice_hypervolt_go_2.png`;
    case 'porvata_adjustable_office_desk_chair_linen':
      return `${root_url}/d8/8b/59/63/63598bd8a4070baae1acde0d/porvata_adjustable_office_desk_chair_porvata_adjustable_office_desk_chair_linen.png`;
    case 'sony_intelligent_industry_leading_noise_canceling_headphones_black':
      return undefined;
    case 'sony_model_true_wireless_noise_canceling_black':
      return `${root_url}/d9/8b/59/63/63598bd928c20569eb0dc6c5/sony_model_true_wireless_noise_canceling_sony_model_true_wireless_noise_canceling_black.png`;
    case 'sound_oasis_glo_to_sleep_advanced_sleep_therapy_mask_gts_2000se':
      return `${root_url}/d9/8b/59/63/63598bd98e7208840f74c847/sound_oasis_glo_to_sleep_advanced_sleep_therapy_mask_gts_2000se.png`;
    case 'tiger_tail_t_1000_vibration_massager':
      return `${root_url}/da/8b/59/63/63598bda6088c403f3c23ff9/tiger_tail_t_1000_vibration_massager.png`;
    case 'wagan_heated_shiatsu_massage_belt':
      return `${root_url}/dc/8b/59/63/63598bdc9dbdb8da0adb3c9f/wagan_wagan_heated_shiatsu_massage_belt.png`;
    case 'withings_body_cardio_black':
      return undefined;
    case 'withings_body_plus_black':
      return `${root_url}/dc/8b/59/63/63598bdcf7de7ce2c5238bcd/withings_body_plus_withings_body_plus_black.png`;
    case 'withings_scanwatch_black_38mm':
      return `${root_url}/dd/8b/59/63/63598bddf7de7ce2c5238bcf/withings_scanwatch_withings_scanwatch_black_38mm.png`;
    case 'withings_sleep':
      return `${root_url}/dd/8b/59/63/63598bdd6088c403f3c23ffc/withings_sleep_withings_sleep.png`;
    case 'vivo_43_x_24_electric_desk_with_black_frame_and_memory_pad_dark_walnut_black':
      return `${root_url}/da/8b/59/63/63598bdaa4070baae1acde0f/vivo_47_24_electric_desk_vivo_47_x_24_electric_desk_with_black_frame_and_memory_pad_dark_walnut_black.png`;
    case 'vivo_pneumatic_arm_single_monitor_desk_mount':
      return `${root_url}/db/8b/59/63/63598bdb9dbdb8da0adb3c9d/vivo_pneumatic_arm_single_monitor_desk_mount_vivo_pneumatic_arm_single_monitor_desk_mount.png`;
    case 'vornado_ultrasonic_humidifier_UH100':
      return `${root_url}/db/8b/59/63/63598bdb9dbdb8da0adb3c9e/vornado_ultrasonic_humidifier_vornado_ultrasonic_humidifier_UH100.png`;
    default:
      return undefined;
  }
};
